import {
	SET_FOCUSED_FOLDERS,
	API_GET_FOCUSED_FOLDERS,
	API_POST_PHOTO_FOLDER,
	API_POST_FOLDER,
	RESET_FOCUSED_FOLDERS,
	API_DELETE_PHOTO_FOLDER,
	API_VALIDATE_FOLDERS,
	SET_SECRETARY_MODE,
	API_GET_FOLDER_BY_CODE,
	API_GET_PATIENT_EXISTING_FOLDER,
	API_PATCH_OPEN_FOLDER,
	API_PATCH_FOLDER_PATIENT,
	API_PATCH_CANCEL_FOLDER,
	API_UPDATE_PHOTO_FOLDER,
	API_GET_PATIENT_CLOSED_FOLDER,
	API_GET_ALL_FOLDER,
	API_PATCH_OPENED_BY,
	API_COUNT_FOLDERS_GESLAB,
	API_GET_SEARCH_FOLDERS,
	API_GET_NEXT_FOLDER_TO_VALIDATE,
	API_GET_FOLDERS_TO_VALIDATE,
	API_GET_NEXT_FOLDER_FUTURE,
	API_GET_FOLDERS_FUTURE,
	API_GET_FOLDERS_COUNT,
	API_PATCH_PAUSE_FOLDER_VALIDATION,
	API_GET_NOT_GENERATED_FOLDERS,
	API_GET_FOLDERS_PAUSED,
	CLOSE_BARCODE_WARNING,
	API_GET_NEXT_FOLDER_TO_SAMPLE,
	CLOSE_OPENEDBY_WARNING,
	API_PATCH_COMMENTS,
	API_PATCH_FOLDER_GESLAB_ALERT,
	API_PATCH_FOLDER_FAMILY_LINK,
	API_GET_SEARCH_FOLDERS_FAMILY_LINK,
	SET_PREVIOUS_FOLDER,
	API_GET_SEARCH_FOLDERS_OPENED,
	API_GET_SEARCH_TEMP_FOLDERS,
	API_PATCH_CONFIRM_TEMP_FOLDER,
	API_ADMIN_IMPORT_TEMP_FOLDERS,
	API_GET_WAITING_TUBES_FOLDERS,
	API_GET_MY_OPENED_FOLDERS,
	API_DELETE_MY_OPENED_FOLDERS,
	SET_TAB_RESULT,
	SET_TAB_PRESC,
	API_PATCH_NOT_GENERATED_FOLDERS,
	SET_TAB_ALIQUOT,
	SET_TAB_TUBES,
	API_GET_WAITING_ALIQUOTS_FOLDERS,
	RESET_ALIQUOTS_WAITING,
	API_GET_FOLDER_HELP,
	API_POST_IDENTITY_CHECK,
	API_GET_FOLDER_BASED_ON_TUBE,
	API_PUT_ENDO_ANSWERS,
	API_POST_MOTIVATIONS,
	API_POST_EXPRESS,
	API_GET_EXPRESS_LIST,
	API_PUT_CENTER_APPOINTMENT_FOLDER,
} from "actions/folder";

import { API_GET_FOLDERS_PATIENT } from "actions/patient";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_POST_FOLDER]: {
		default: "/folders",
		v2: "/folders",
		currentClient: V2_CLIENT,
	},
	[API_PATCH_OPEN_FOLDER]: {
		default: (folderId) => `/folders/${folderId}/open`,
		v2: (folderId) => `/folders/${folderId}/open`,
		currentClient: V2_CLIENT,
	},
	[API_PATCH_FOLDER_PATIENT]: {
		default: (folderId, patientId) => `/folders/${folderId}/patient/${patientId}`,
		v2: (folderId, patientId) => `/folders/${folderId}/patient/${patientId}`,
		currentClient: V2_CLIENT,
	},
	[API_PATCH_CANCEL_FOLDER]: {
		default: (folderId) => `/folders/${folderId}/cancel`,
		v2: (folderId) => `/folders/${folderId}/cancel`,
		currentClient: V2_CLIENT,
	},
	[API_PATCH_OPENED_BY]: {
		default: (folderId) => `/folders/${folderId}/openedby`,
		v2: (folderId) => `/folder/${folderId}/openedby`,
		currentClient: V2_CLIENT,
	},
	[API_PATCH_PAUSE_FOLDER_VALIDATION]: {
		default: (folderId) => `/folders/${folderId}/pause`,
		v2: (folderId) => `/folders/${folderId}/pause`,
		currentClient: V2_CLIENT,
	},
	[API_PATCH_COMMENTS]: {
		default: (folderId) => `/folders/${folderId}/comments`,
		v2: (folderId) => `/folders/${folderId}/comments`,
		currentClient: V2_CLIENT,
	},
	[API_PATCH_FOLDER_GESLAB_ALERT]: {
		default: (folderId) => `/folders/${folderId}/geslabAlert`,
		v2: (folderId) => `/folders/${folderId}/geslabAlert`,
		currentClient: V2_CLIENT,
	},
	[API_PATCH_FOLDER_FAMILY_LINK]: {
		default: (folderId, parentId) => `/folders/${folderId}/${parentId}/link`,
		v2: (folderId, parentId) => `/folders/${folderId}/${parentId}/link`,
		currentClient: V2_CLIENT,
	},
	[API_GET_FOCUSED_FOLDERS]: {
		default: "/folders/manager",
		v2: (folderId) => `/folder/${folderId}`,
		currentClient: V2_CLIENT,
	},
	[API_GET_FOLDER_BY_CODE]: {
		default: (code) => `/folders/${code}`,
		v2: (code) => `/folders/${code}`,
		currentClient: V2_CLIENT,
	},
	[API_GET_PATIENT_EXISTING_FOLDER]: {
		default: (patientId) => `/folders/${patientId}/existing`,
		v2: (patientId) => `/folders/${patientId}/existing`,
		currentClient: V2_CLIENT,
	},
	[API_GET_ALL_FOLDER]: {
		default: "/folders",
		v2: "/folders",
		currentClient: V2_CLIENT,
	},
	[API_GET_SEARCH_FOLDERS]: {
		default: "/folders/search",
		v2: "/folders/search",
		currentClient: V2_CLIENT,
	},
	[API_PATCH_CONFIRM_TEMP_FOLDER]: {
		default: (folderId) => `/folders/${folderId}/confirm`,
		v2: (folderId) => `/folders/${folderId}/confirm`,
		currentClient: V2_CLIENT,
	},
	[API_GET_SEARCH_FOLDERS_FAMILY_LINK]: {
		default: (centerId, folderId) => `/folders/search/${centerId}/family_link`,
		v2: (centerId, folderId) => `/folders/search/${centerId}/family_link`,
		currentClient: V2_CLIENT,
	},
	[API_GET_FOLDER_HELP]: {
		default: (folderHelpId) => `/helpFolder/${folderHelpId}`,
		v2: (folderHelpId) => `/folder-help/${folderHelpId}`,
		currentClient: V2_CLIENT,
	},
};

export function getPatientFolders(id) {
	return {
		type: API_GET_FOLDERS_PATIENT,
		payload: {
			request: {
				url: `/folders/patient/${id}`,
			},
			id: id,
		},
	};
}

export function getFolderByCode(code) {
	const version = getVersion(API_GET_FOLDER_BY_CODE);
	const url = typeof version.path === 'function' ? version.path(code) : version.path;
	return {
		type: API_GET_FOLDER_BY_CODE,
		payload: {
			request: {
				url,
			},
			client: version.currentClient,
		},
	};
}

export function setFocusedFolders(foldersID) {
	return {
		type: SET_FOCUSED_FOLDERS,
		payload: foldersID,
	};
}

export function setSecretaryMode(mode) {
	return {
		type: SET_SECRETARY_MODE,
		payload: mode,
	};
}

export function getFocusedFolders(foldersID) {
	const version = getVersion(API_GET_FOCUSED_FOLDERS);
	
	if (version.currentClient === V2_CLIENT) {
		const folderId = Array.isArray(foldersID) && foldersID.length > 0 ? foldersID[0] : foldersID;
		const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
		
		return {
			type: API_GET_FOCUSED_FOLDERS,
			payload: {
				request: {
					url,
					method: "GET",
				},
				client: version.currentClient,
				folderIds: foldersID,
			},
		};
	}
	
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_FOCUSED_FOLDERS,
		payload: {
			request: {
				url,
				method: "POST",
				data: foldersID,
			},
			client: version.currentClient,
		},
	};
}

export function resetFocusedFolders() {
	return {
		type: RESET_FOCUSED_FOLDERS,
	};
}

export function postFolder(patientId, appointmentId = null, labAppointmentId = null, comment = null) {
	const version = getVersion(API_POST_FOLDER);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_POST_FOLDER,
		payload: {
			request: {
				url,
				method: "POST",
				data: {
					patient: patientId,
					appointment: appointmentId,
					labAppointment: labAppointmentId,
					comment: comment,
				},
			},
			client: version.currentClient,
		},
	};
}

export function postPhotoFolder(photo, folderId) {
	return {
		type: API_POST_PHOTO_FOLDER,
		payload: {
			request: {
				config: { headers: { "Content-Type": "multipart/form-data" } },
				url: `/folders/${folderId}/photo`,
				method: "POST",
				data: photo,
			},
			folderId: folderId,
		},
	};
}

export function updatePhotoFolder(folderId, photoId, comment, barcode) {
	return {
		type: API_UPDATE_PHOTO_FOLDER,
		payload: {
			request: {
				url: `/folders/photo/${photoId}`,
				method: "patch",
				data: {
					comment,
					barcode,
				},
			},
			folderId: folderId,
		},
	};
}

export function deletePhotoFolder(photoId) {
	return {
		type: API_DELETE_PHOTO_FOLDER,
		payload: {
			request: {
				url: `/folders/photo/${photoId}`,
				method: "DELETE",
			},
		},
	};
}

export function validateFolders(foldersID, incrementTakeNumber, centerId) {
	return {
		type: API_VALIDATE_FOLDERS,
		payload: {
			request: {
				url: `/folders/validate`,
				method: "POST",
				data: {
					foldersID: foldersID,
					incrementTakeNumber: incrementTakeNumber,
					centerId: centerId,
				},
			},
		},
	};
}

export function getPatientExistingFolder(patientId) {
	const version = getVersion(API_GET_PATIENT_EXISTING_FOLDER);
	const url = typeof version.path === 'function' ? version.path(patientId) : version.path;
	return {
		type: API_GET_PATIENT_EXISTING_FOLDER,
		payload: {
			request: {
				url,
				method: "GET",
			},
			client: version.currentClient,
		},
	};
}

export function openFolder(folderId) {
	const version = getVersion(API_PATCH_OPEN_FOLDER);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_PATCH_OPEN_FOLDER,
		payload: {
			request: {
				url,
				method: "patch",
			},
			client: version.currentClient,
		},
	};
}

export function cancelFolder(folderId, canceled_reason) {
	const version = getVersion(API_PATCH_CANCEL_FOLDER);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_PATCH_CANCEL_FOLDER,
		payload: {
			request: {
				url,
				method: "patch",
				data: {
					canceled_reason,
				},
			},
			client: version.currentClient,
		},
	};
}

export function changePatient(folderId, patientId) {
	const version = getVersion(API_PATCH_FOLDER_PATIENT);
	const url = typeof version.path === 'function' ? version.path(folderId, patientId) : version.path;
	return {
		type: API_PATCH_FOLDER_PATIENT,
		payload: {
			request: {
				url,
				method: "patch",
			},
			client: version.currentClient,
		},
	};
}

export function getPatientClosedFolders(patientId, size = 5) {
	return {
		type: API_GET_PATIENT_CLOSED_FOLDER,
		payload: {
			request: {
				url: `/folders/${patientId}/closed`,
				method: "get",
				params: {
					size: size,
				},
			},
		},
	};
}

export function getAllFolders() {
	const version = getVersion(API_GET_ALL_FOLDER);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_ALL_FOLDER,
		payload: {
			request: {
				url,
				method: "get",
			},
			client: version.currentClient,
		},
	};
}

export function assignOpenedBy(folderId, forceAssign = false) {
	const version = getVersion(API_PATCH_OPENED_BY);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_PATCH_OPENED_BY,
		payload: {
			request: {
				url,
				method: "patch",
				data: {
					forceAssign,
				},
			},
			client: version.currentClient,
		},
	};
}

export function unassignOpenedBy(folderId) {
	const version = getVersion(API_PATCH_OPENED_BY);
	return {
		type: API_PATCH_OPENED_BY,
		payload: {
			request: {
				url: version.currentClient === V2_CLIENT 
					? `/folder/${folderId}/unassign`
					: `/folders/${folderId}/openedby/unassign`,
				method: "patch",
			},
			client: version.currentClient,
		},
	};
}

export function countFolderSentToGesLab(date1, date2) {
	return {
		type: API_COUNT_FOLDERS_GESLAB,
		payload: {
			request: {
				url: `/folders/geslab`,
				method: "get",
				params: {
					date1: date1,
					date2: date2,
				},
			},
		},
	};
}

export function searchFolders(search, options, size = 30, page = 1) {
	const version = getVersion(API_GET_SEARCH_FOLDERS);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_SEARCH_FOLDERS,
		payload: {
			request: {
				url,
				method: "get",
				params: {
					page,
					size,
					search,
					options,
				},
			},
			client: version.currentClient,
		},
	};
}

export function getNextFolderToValidate(paused = false) {
	return {
		type: API_GET_NEXT_FOLDER_TO_VALIDATE,
		payload: {
			request: {
				url: `/folders/tovalidate/next`,
				method: "get",
				params: {
					paused,
				},
			},
		},
	};
}

export function getFoldersToValidate(page = 1, size = 20) {
	return {
		type: API_GET_FOLDERS_TO_VALIDATE,
		payload: {
			request: {
				url: `/folders/tovalidate/`,
				method: "get",
				params: {
					page,
					size,
					paused: false,
				},
			},
		},
	};
}

export function getFoldersPaused(page = 1, size = 20) {
	return {
		type: API_GET_FOLDERS_PAUSED,
		payload: {
			request: {
				url: `/folders/tovalidate/`,
				method: "get",
				params: {
					page,
					size,
					paused: true,
				},
			},
		},
	};
}

export function getNextFolderFuture() {
	return {
		type: API_GET_NEXT_FOLDER_FUTURE,
		payload: {
			request: {
				url: `/folders/future/next`,
				method: "get",
			},
		},
	};
}

export function getFoldersFuture(page = 1, size = 20) {
	return {
		type: API_GET_FOLDERS_FUTURE,
		payload: {
			request: {
				url: `/folders/future/`,
				method: "get",
				params: {
					page,
					size,
				},
			},
		},
	};
}

export function getFoldersCount() {
	return {
		type: API_GET_FOLDERS_COUNT,
		payload: {
			request: {
				url: `/folders/count/`,
				method: "get",
			},
		},
	};
}

export function pauseFolderValidation(folderId, reason) {
	const version = getVersion(API_PATCH_PAUSE_FOLDER_VALIDATION);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_PATCH_PAUSE_FOLDER_VALIDATION,
		payload: {
			request: {
				url,
				method: "patch",
				data: {
					reason,
				},
			},
			client: version.currentClient,
		},
	};
}

export function getNotGeneratedFolders(search, page = 1, size = 20) {
	return {
		type: API_GET_NOT_GENERATED_FOLDERS,
		payload: {
			request: {
				url: `/folders/notgenerated`,
				method: "get",
				params: {
					search,
					page,
					size,
				},
			},
		},
	};
}

export function patchNotGeneratedFolders() {
	return {
		type: API_PATCH_NOT_GENERATED_FOLDERS,
		payload: {
			request: {
				url: `/folders/notgenerated`,
				method: "patch",
			},
		},
	};
}

export function closeBarcodeWarningOpen() {
	return {
		type: CLOSE_BARCODE_WARNING,
	};
}

export function closeOpenedByWarning() {
	return {
		type: CLOSE_OPENEDBY_WARNING,
	};
}

export function getNextFolderToSample(center_id, previousFolder = null) {
	return {
		type: API_GET_NEXT_FOLDER_TO_SAMPLE,
		payload: {
			request: {
				url: `/folders/tosample/next/${center_id}`,
				method: "get",
				params: {
					previous_folder: previousFolder,
				},
			},
		},
	};
}

export function updateCommentAndPostit(folderId, data) {
	const version = getVersion(API_PATCH_COMMENTS);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_PATCH_COMMENTS,
		payload: {
			request: {
				url,
				method: "patch",
				data: data,
			},
			client: version.currentClient,
		},
	};
}

export function patchGeslabAlert(folderId, values) {
	const version = getVersion(API_PATCH_FOLDER_GESLAB_ALERT);
	const url = typeof version.path === 'function' ? version.path(folderId) : version.path;
	return {
		type: API_PATCH_FOLDER_GESLAB_ALERT,
		payload: {
			request: {
				url,
				method: "patch",
				data: values,
			},
			client: version.currentClient,
		},
	};
}

export function setFamilyLink(folderId, parentId) {
	const version = getVersion(API_PATCH_FOLDER_FAMILY_LINK);
	const url = typeof version.path === 'function' ? version.path(folderId, parentId) : version.path;
	return {
		type: API_PATCH_FOLDER_FAMILY_LINK,
		payload: {
			request: {
				url,
				method: "patch",
			},
			client: version.currentClient,
		},
	};
}

export function searchFoldersFamilyLink(centerId, folderId, search) {
	const version = getVersion(API_GET_SEARCH_FOLDERS_FAMILY_LINK);
	const url = typeof version.path === 'function' ? version.path(centerId, folderId) : version.path;
	return {
		type: API_GET_SEARCH_FOLDERS_FAMILY_LINK,
		payload: {
			request: {
				url,
				method: "get",
				params: {
					search,
					folder_id: folderId,
				},
			},
			client: version.currentClient,
		},
	};
}

export function setPreviousFolder(id) {
	return {
		type: SET_PREVIOUS_FOLDER,
		payload: id,
	};
}

export function searchFoldersOpened(search, center_id = null, user_id = null, page = 1, size = 20) {
	return {
		type: API_GET_SEARCH_FOLDERS_OPENED,
		payload: {
			request: {
				url: `/folders/search/opened`,
				method: "get",
				params: {
					search,
					page,
					size,
					center_id,
					user_id,
				},
			},
		},
	};
}

export function searchTempFolders(search, page = 1, size = 20) {
	return {
		type: API_GET_SEARCH_TEMP_FOLDERS,
		payload: {
			request: {
				url: `/folders/search/temp`,
				method: "get",
				params: {
					search,
					page,
					size,
				},
			},
		},
	};
}

export function confirmTempFolder(folder_id, center_id) {
	const version = getVersion(API_PATCH_CONFIRM_TEMP_FOLDER);
	const url = typeof version.path === 'function' ? version.path(folder_id) : version.path;
	return {
		type: API_PATCH_CONFIRM_TEMP_FOLDER,
		payload: {
			request: {
				url,
				method: "patch",
				data: { center_id },
			},
			client: version.currentClient,
		},
	};
}

export function adminImportTempFolders(file) {
	const formData = new FormData();
	formData.append("file", file);
	return {
		type: API_ADMIN_IMPORT_TEMP_FOLDERS,
		payload: {
			request: {
				config: { headers: { "Content-Type": "multipart/form-data" } },
				url: `/admin/folders/temp/import`,
				method: "post",
				data: formData,
			},
		},
	};
}

export function getFoldersWaitingTubes() {
	return {
		type: API_GET_WAITING_TUBES_FOLDERS,
		payload: {
			request: {
				url: `/folders/timerWaiting/`,
				method: "GET",
			},
		},
	};
}

export function getFoldersWaitingAliquots(center_id) {
	return {
		type: API_GET_WAITING_ALIQUOTS_FOLDERS,
		payload: {
			request: {
				url: `/folders/aliquotWaiting/${center_id}`,
				method: "GET",
			},
		},
	};
}
export function searchFolderWithTube(tube_barcode) {
	return {
		type: API_GET_FOLDER_BASED_ON_TUBE,
		payload: {
			request: {
				url: `/folders/tube/${tube_barcode}`,
				method: "GET",
			},
		},
	};
}

export function resetWaitingAliquots() {
	return {
		type: RESET_ALIQUOTS_WAITING,
	};
}

export function getMyOpenedFolders() {
	return {
		type: API_GET_MY_OPENED_FOLDERS,
		payload: {
			request: {
				url: `/folders/myopened/`,
				method: "GET",
			},
		},
	};
}

export function closeAllMyOpenedFolder() {
	return {
		type: API_DELETE_MY_OPENED_FOLDERS,
		payload: {
			request: {
				url: `/folders/myopened/`,
				method: "DELETE",
			},
		},
	};
}

export function goToResult() {
	return {
		type: SET_TAB_RESULT,
	};
}
export function cancelTab() {
	return {
		type: SET_TAB_PRESC,
	};
}
export function goToAliquot() {
	return {
		type: SET_TAB_ALIQUOT,
	};
}
export function goToTubes() {
	return {
		type: SET_TAB_TUBES,
	};
}

export function getFolderHelp(folderHelpId) {
	const version = getVersion(API_GET_FOLDER_HELP);
	const url = typeof version.path === 'function' ? version.path(folderHelpId) : version.path;
	return {
		type: API_GET_FOLDER_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function postIdentityCheck(identity, folderId) {
	return {
		type: API_POST_IDENTITY_CHECK,
		payload: {
			request: {
				url: `/identity/${folderId}`,
				method: "POST",
				data: identity,
			},
		},
	};
}
export function putEndoAnswers(endoAnswers, folderId) {
	return {
		type: API_PUT_ENDO_ANSWERS,
		payload: {
			request: {
				url: `/endo/${folderId}`,
				method: "PUT",
				data: endoAnswers,
			},
		},
	};
}

export function postMotivations(values, folderId) {
	return {
		type: API_POST_MOTIVATIONS,
		payload: {
			request: {
				method: "POST",
				url: `/motivations/${folderId}`,
				data: values,
			},
		},
	};
}

export function postExpress(values) {
	return {
		type: API_POST_EXPRESS,
		payload: {
			request: {
				method: "POST",
				url: `/express`,
				data: values,
			},
		},
	};
}

export function associateCenterAppointmentWithFolder(centerAppointmentId, folderId) {
	return {
		type: API_PUT_CENTER_APPOINTMENT_FOLDER,
		payload: {
			request: {
				method: "PUT",
				url: `/center_app/${centerAppointmentId}/folder/${folderId}`,
			},
		},
	};
}

export function getListExpress() {
	return {
		type: API_GET_EXPRESS_LIST,
		payload: {
			request: {
				method: "GET",
				url: `/express`,
			},
		},
	};
}
